import React from "react";

import svg from "../../assets/images/icons/settings.svg";

export const SettingIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Setting"}
    />
);
